<template>
  <div class="has-text-centered">
    Loading...
  </div>
</template>

<script>

export default {
  mounted() {
    switch (this.$route.params.name) {
      case 'special-1':
        this.$router.push({name: 'Training', query: { tn: 'Beine-Special (hard)' }})
        break
      case 'special-2':
        this.$router.push({name: 'Training', query: { tn: 'Triple X (easy)' }})
        break
      case 'special-3':
        this.$router.push({name: 'Training', query: { tn: 'Reynolds (hard)' }})
        break
      case 'special-4':
        this.$router.push({name: 'Training', query: { tn: 'Statham (moderate)' }})
        break
      case 'special-5':
        this.$router.push({name: 'Training', query: { tn: 'Gosling (easy)' }})
        break
      default:
        this.$router.push({name: 'Training'})
        break
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Settings/TrainingRedirect.vue